import { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import general from "../../general";
import Dialog from "../../lib/Dialog";
import { useHistory } from "react-router-dom";
import Image from "../../lib/Image";
import useUrlState from "@ahooksjs/use-url-state";

export default ({ active, setTitle }) => {
  const [query] = useUrlState({ keyword: "" });
  let [tradeKeyword, setTradeKeyword] = useState(query.keyword);

  let clickCount = 0;

  const history = useHistory();
  const tradeClickSearch = () => {
    history.replace({
      pathname: "/screen-trade",
      search: `?keyword=${tradeKeyword}`,
    });
  };

  useEffect(() => {
    setTitle(
      <div className="search-index-input" style={{ marginLeft: "7px" }}>
        <div className="search-index-input-left">
          <img
            className="search-index-input-icon"
            src="/resources/common/search.png"
            alt=""
          />

          <div className="search-index-input-main">
            <input
              className="search-index-input-main-input"
              type="text"
              autoFocus
              value={tradeKeyword}
              placeholder={"请输入游戏名称"}
              onMouseDown={() => {
                clickCount++;
                if (clickCount > 2) {
                  Dialog.info(
                    <div>
                      若遇到iOS系统键盘问题，请
                      <br />
                      重启手机或我的-&gt;联系客服
                    </div>
                  );
                  clickCount = 0;
                }
              }}
              onChange={(e) => {
                setTradeKeyword(e.target.value);
              }}
              enterKeyHint="search"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // 避免默认提交

                  tradeClickSearch();
                }
              }}
            />
          </div>

          {tradeKeyword ? (
            <CloseOutlined
              className="close"
              onClick={() => {
                setTradeKeyword("");
              }}
            />
          ) : null}
        </div>

        <div className="search-index-input-right">
          <div className="line"></div>
          <div className="search-index-btn" onClick={tradeClickSearch}>
            搜索
          </div>
        </div>
      </div>
    );
  }, [tradeKeyword]);

  const [gameList, setGameList] = useState([]);
  useEffect(() => {
    Dialog.loading();
    general.axios
      .post("/v3/user/trade/HotTradeGameList")
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        console.log("交易热门游戏---", res);
        let { status, data } = res.data;
        if (!status.succeed) {
          return;
        }

        setGameList(data);
      })
      .catch((err) => {
        Dialog.error("HotTradeGameList " + err.message);
      });
  }, []);

  return (
    <>
      {gameList?.length > 0 && (
        <div className="trade-search">
          <div className="trade-search-title">热门游戏</div>
          <div className="trade-search-content">
            {gameList.map((item) => (
              <div
                className="trade-search-content-item"
                key={item.game_id}
                onClick={() => {
                  history.replace({
                    pathname: "/screen-trade",
                    search: `?keyword=${item.game_name_main}`,
                  });
                }}
              >
                <Image src={item.logo} alt="" />
                <div className="trade-search-content-item-name">
                  {item.game_name_main}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
